import { Button, IconButton, Modal, Typography } from '@volvo/vcdk-react';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

type Props = {
  campaignTitle: string;
  campaignCode?: string;
  campaignInformation?: string;
};

const ReleaseNotesModal: React.FC<Props> = ({ campaignTitle, campaignCode, campaignInformation }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <IconButton variant="tertiary" icon="info" onClick={() => setIsOpen(true)} />
      {isOpen &&
        createPortal(
          <Modal open={isOpen} onClose={() => setIsOpen(false)} width={600} maxWidth="90%">
            <span slot="header">Release notes</span>
            <section className="mb-6 flex flex-col gap-6">
              <Typography variant="body">
                {campaignTitle}
                <br />
                {'E-code: ' + (campaignCode ?? '<missing ecode>')}
              </Typography>
              <Typography>{campaignInformation ?? 'Missing release notes'}</Typography>
            </section>
            <span slot="footer">
              <Button variant="primary" onClick={() => setIsOpen(false)}>
                {t(($) => $.common.close)}
              </Button>
            </span>
          </Modal>,
          document.body
        )}
    </>
  );
};

export default withComponentErrorBoundary(ReleaseNotesModal);
